import { get, post, del } from '../utils/request';
import { Attachment } from './lead';

/**
 * Upload attachment
 */
export const uploadAttachment = async (
  file: File,
  entityType: string,
  entityId: number,
  category?: string
): Promise<Attachment> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('target_type', entityType);
  formData.append('target_id', entityId.toString());
  if (category) {
    formData.append('category', category);
  }

  return post<Attachment>('/attachments/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

/**
 * Get attachments for entity
 */
export const getEntityAttachments = async (
  entityType: string,
  entityId: number
): Promise<Attachment[]> => {
  return get<Attachment[]>(`/attachments/entity/${entityType}/${entityId}`);
};

/**
 * Delete attachment
 */
export const deleteAttachment = async (id: number): Promise<void> => {
  return del<void>(`/attachments/${id}`);
};

/**
 * Get current user's uploaded attachments
 */
export const getMyUploads = async (skip = 0, limit = 100): Promise<Attachment[]> => {
  return get<Attachment[]>(`/attachments/my-uploads`, {
    params: { skip, limit }
  });
};